export default __webpack_public_path__ + "static/media/IconDesc_QuantumComputer.256.9c899fa5.png";